export const TEST_ID_FLIGHTS_RESULTS = 'TEST_ID_FLIGHTS_RESULTS';
export const TEST_ID_FLIGHTS_SKELETON = 'TEST_ID_FLIGHTS_SKELETON';
export const FLIGHT_LIST_ID = 'FLIGHT_LIST_ID';
